import { generateMutations } from '../builder'

export default {
  ...generateMutations('getCategories', 'categories'),
  ...generateMutations('getCategory', 'category'),
}
